export const verifyToken = async (token, gameType = "mines") => {
    try {
      const response = await fetch("https://mines-backend.desiapi.com/api/user/verifyToken", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, gameType }),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error verifying token:", error);
      return { status: false, message: "Error verifying token" };
    }
  };
  
  export const connectSocket = (token, onMessage, onError, onOpen, onClose) => {
    const ws = new WebSocket("wss://mines-backend.desiapi.com/ws/", token);
  
    ws.onopen = () => {
      if (onOpen) onOpen();
    };
  
    ws.onmessage = (event) => {
      const response = JSON.parse(event.data);
      if (onMessage) onMessage(response);
    };
  
    ws.onerror = (error) => {
      if (onError) onError(error);
    };
  
    ws.onclose = () => {
      if (onClose) onClose();
    };
  
    return ws;
  };
  
  export const subscribeToChannel = (socket, gameType = "mines") => {
    if (!socket) return;
    const subscribeMessage = {
      type: "SUBSCRIBE",
      gameType: gameType,
    };
    socket.send(JSON.stringify(subscribeMessage));
  };
  
  export const unsubscribeFromChannel = (socket, gameType = "mines") => {
    if (!socket) return;
    const unsubscribeMessage = {
      type: "UNSUBSCRIBE",
      gameType: gameType,
    };
    socket.send(JSON.stringify(unsubscribeMessage));
  };
  
  export const startGame = (socket, { userId, mineCount, betAmount, gameType = "mines" }) => {
    if (!socket || socket.readyState !== WebSocket.OPEN) return false;
    const startGameMessage = {
      type: "START_GAME",
      gameType,
      userId,
      mineCount,
      betAmount,
    };
    try { socket.send(JSON.stringify(startGameMessage)); return true; }
    catch { return false; }
  };
  
  export const revealBlock = (socket, { userId, sessionId, blockIndex, gameType = "mines" }) => {
    if (!socket) return;
    const revealBlockMessage = {
      type: "REVEAL_BLOCK",
      gameType,
      userId,
      sessionId,
      blockIndex,
    };
    socket.send(JSON.stringify(revealBlockMessage));
  };
  
  export const claimGame = (socket, { userId, sessionId, gameType = "mines" }) => {
    if (!socket) return;
    const claimMessage = {
      type: "CLAIM_AMOUNT",
      gameType,
      userId,
      sessionId,
    };
    socket.send(JSON.stringify(claimMessage));
  };
  
  export const getAllBets = (socket, gameType = "mines") => {
    if (!socket) return;
    const allBetsMessage = {
      type: "ALL_BETS",
      gameType,
    };
    socket.send(JSON.stringify(allBetsMessage));
  };
  
  export const getMyBets = (socket, gameType = "mines") => {
    if (!socket) return;
    const myBetsMessage = {
      type: "MY_BETS",
      gameType,
    };
    socket.send(JSON.stringify(myBetsMessage));
  };
  
  export const getTopBets = (socket, gameType = "mines") => {
    if (!socket) return;
    const topBetsMessage = {
      type: "TOP_BETS",
      gameType,
    };
    socket.send(JSON.stringify(topBetsMessage));
  };
  
  export const handleWebSocketMessage = (message) => {
    switch (message.type) {
      case "USER_BALANCE":
        //console.log(`User balance: ${message.userBalance}`);
        break;
      case "SESSION_HISTORY":
        //console.log(`Session history for game: ${message.issue}:`, message.sessions);
        break;
      case "NOTIFICATION":
        //console.log(`Notification: ${message.notification.text}`);
        break;
      case "GAME_STARTED":
        //console.log(`Game started for session: ${message.sessionId}`);
        break;
      case "GAME_ENDED":
        //console.log(`Game ended. Winning amount: ${message.winAmount}`);
        break;
      case "BET_RESULT":
        //console.log(`Bet result for session: ${message.sessionId}`);
        //console.log(`Bet status: ${message.result.status}, Win amount: ${message.result.winAmount}`);
        break;
      case "COUNT_DOWN":
        //console.log(`Countdown for session: ${message.sessionId}. Time left: ${message.remainingTime}`);
        break;
      case "BETTING_CLOSED":
        //console.log(`Betting closed for session: ${message.sessionId}`);
        break;
      case "ERROR":
        //console.log(`Error: ${message.message}`);
        break;
      default:
        //console.log(`Received unknown message type: ${message.type}`);
    }
  };
  

  export const calculateWinBlocks = (betAmount, mineCount, blockIndex) => {
  const baseMultiplier = 1.01 + (mineCount - 1) * 0.01;
  const increment = 0.05 + (mineCount - 1) * 0.01;

  const finalAmount = betAmount * (baseMultiplier + increment * blockIndex);
  return { 
    multiplier: baseMultiplier + increment * blockIndex, 
    amount: finalAmount.toFixed(2)
  };
};
